// extracted by mini-css-extract-plugin
module.exports = {"placeholderContainer":"SignatureWidget_placeholderContainer__1Mv4f","placeholder":"SignatureWidget_placeholder__1jcRb","mark":"SignatureWidget_mark__1CMMI"};